import flattenRoutes from 'utils/flattenRoutes';
import getRoutes from 'utils/getRoutes';

export const mainRoutes = [
  {
    name: 'home',
    href: '/',
    icon: 'home',
    label: 'Inicio',
    title: 'Principal',
    routes: [
      {
        name: 'account',
        href: '/account/',
        icon: 'account_circle',
        label: 'Mi cuenta',
        title: 'Administrar perfil',
      },
      {
        name: 'characters',
        href: '/characters/',
        icon: 'sports_martial_arts',
        label: 'Personajes',
        title: 'Mis personajes',
        routes: [
          {
            name: 'character',
            href: '/characters/[cid]/',
            label: 'Personaje',
            title: 'Ver personaje',
            readOnly: true,
          },
        ],
      },
      {
        name: 'library',
        href: '/library/',
        icon: 'books',
        label: 'Biblioteca',
        title: 'Mis historias',
        routes: [
          {
            name: 'read',
            href: '/library/[bid]/',
            label: 'Historia',
            title: 'Leer cuento',
            readOnly: true,
          },
          {
            name: 'create',
            href: '/library/new/',
            icon: 'add_circle_outline',
            label: 'Crear cuento',
            title: 'Nueva historia',
            routes: [
              {
                name: 'build',
                href: '/library/build/',
                label: 'Asistido',
                title: 'Nueva historia',
                readOnly: true,
              },
              {
                name: 'imagine',
                href: '/library/imagine/',
                label: 'Libre',
                title: 'Nueva historia',
                readOnly: true,
              },
            ],
          },
          {
            name: 'explore',
            href: '/library/explore/',
            icon: 'explore',
            label: 'Explorar',
            title: 'Base de datos',
          },
          {
            name: 'favorites',
            href: '/library/favorites/',
            icon: 'favorite_outlined',
            label: 'Favoritos',
            title: 'Mis favoritos',
          },
        ],
      },
      {
        name: 'notifications',
        href: '/notifications/',
        icon: 'notifications',
        label: 'Notificaciones',
        title: 'Mis notificaciones',
      },
      {
        name: 'settings',
        href: '/settings/',
        icon: 'settings',
        label: 'Ajustes',
        title: 'Configuración',
      },
      {
        name: 'subscription',
        href: '/subscription/',
        icon: 'payment',
        label: 'Suscripción',
        title: 'Administrar suscripción',
      },
      {
        name: 'support',
        href: '/support/',
        icon: 'support_agent',
        label: 'Ayuda',
        title: 'Soporte y ayuda',
      },
    ],
  },
  {
    name: 'login',
    href: '/login/',
    title: 'Acceso',
    public: true,
  },
  {
    name: 'register',
    href: '/register/',
    title: 'Registro',
    public: true,
  },
];

export const accountRoutes = getRoutes(
  ['account', 'subscription', 'library' /*, "characters" */],
  mainRoutes
);

export const appbarRoutes = getRoutes(
  ['home', 'library', ['create', 'imagine', 'build'], 'explore'],
  mainRoutes
);

export const homeRoutes = getRoutes(
  ['library', /*"characters",*/ 'explore', 'subscription'],
  mainRoutes
);

export const sidebarRoutes = getRoutes(
  [
    'home',
    //"notifications",
    'library',
    'subscription',
    //"characters",
    //"favorites",
    'explore',
    'account',
    //"support",
  ],
  mainRoutes
);

export const topbarRoutes = getRoutes(
  ['home', ['library', 'explore', 'read'], ['create', 'imagine', 'build']],
  mainRoutes
);

export const publicRoutes = getRoutes(['login', 'register'], mainRoutes);

const routes = flattenRoutes(mainRoutes);

export default routes;
